import { Heading, PrimaryButton } from '@dot/design-system';
import { useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

import BackIcon from '@/assets/icons/ID-card-back.svg?react';
import TurnIcon from '@/assets/icons/ID-card-front-50.svg?react';
import FrontIcon from '@/assets/icons/ID-card-front.svg?react';
import * as GSC from '@/styles/GlobalStyles';
import { animationContainer, baseFrame, instructionText, overlayButtonGroup } from '@/styles/helpers';

export const Animation = styled.div`
  ${animationContainer};
`;

export const BaseFrame = styled.div`
  ${baseFrame};
`;

export const NextFrame = styled(BaseFrame)<{ $animationDelay: number }>`
  animation-delay: ${(props) => props.$animationDelay}s;
  opacity: 0;
`;

export const Instruction = styled.div`
  ${instructionText};
`;

export const OverlayButtonGroup = styled.div`
  ${overlayButtonGroup};
`;

export type DocumentReviewProps = {
  capturedImage: Blob | null;
  onContinue?: () => void;
  onSkip?: () => void;
};

export const DocumentReview = ({ capturedImage, onContinue, onSkip }: DocumentReviewProps) => {
  const { t } = useTranslation();

  return (
    <GSC.InfoContainer>
      {capturedImage && <GSC.BlobImage alt="captured image" blob={capturedImage} />}
      <GSC.DarkOverlay />
      <Animation>
        <BaseFrame>
          <FrontIcon />
        </BaseFrame>
        <NextFrame $animationDelay={0.5}>
          <TurnIcon />
        </NextFrame>
        <NextFrame $animationDelay={1}>
          <BackIcon />
        </NextFrame>
        <NextFrame $animationDelay={1.5}>
          <TurnIcon />
        </NextFrame>
      </Animation>
      <Instruction>
        <Heading as="h3">{t('steps.documentReview.instruction')}</Heading>
      </Instruction>
      {onSkip || onContinue ? (
        <OverlayButtonGroup>
          {/* {onSkip && (
            <WhiteButton data-test-id="btn_skip_page" onClick={onSkip} size="sm">
              {t('steps.documentReview.skipButton')}
            </WhiteButton>
          )} */}
          {onContinue && (
            <PrimaryButton data-test-id="btn_continue_verif" onClick={onContinue} size="sm">
              {t('steps.documentReview.continueButton')}
            </PrimaryButton>
          )}
        </OverlayButtonGroup>
      ) : null}
    </GSC.InfoContainer>
  );
};
